import type { RuntimeConfig } from './runtime-config';
import { useInternalHost } from './use-internal-host';

export function useRuntimeConfig(): RuntimeConfig {
  return useInternalHost().config;
}
